module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Roles</span></div>\r\n<div class=\"row prop-detail\">\r\n    <div id=\"propMainGridButtons\" class=\"col-sm-12\">\r\n        <div class=\"add_overflow_y\">\r\n            <table id=\"propMainTable\"></table>\r\n        </div>\r\n    </div>\r\n\r\n\r\n    <div id=\"propMainGridButtons\" class=\"col-sm-12\" style=\"padding-top:5px;\">\r\n        <div class=\"row\">\r\n            <div class=\"col-sm-12\" style=\"padding-left: 0px;\">\r\n                <button class=\"btn btn-default btn-sm itemNew\" style=\"width:60px;\" name=\"itemNew\">Add</button>\r\n                <button class=\"btn btn-default btn-sm itemRemove\" style=\"width:60px;\" name=\"itemRemove\">Remove</button>\r\n                <button class=\"btn btn-default btn-sm itemEdit\" style=\"width:60px;\" name=\"itemEdit\">Edit</button>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>")
  }
  return __output;

}